export default __webpack_public_path__ + "static/media/ViewComp.5d2210f4.svg";